import { useState } from 'react';
import './Login.css';
import { useNavigate } from 'react-router-dom';

function Register() {  
const navigate = useNavigate();
const[user,setUser]=useState('')
const[password,setPassword]=useState('')

const Login = async () => {
console.log(user,password)
fetch(`https://msensorapi.coolproyectdata.online/signup.php`, {
method: "POST",
headers: {
Accept: "application/json",
'Content-Type': 'application/x-www-form-urlencoded',
},
body:JSON.stringify({
"email":user,
"password":password
})
})
.then((response) => response.json())
.then((responseData) => {
console.log(JSON.stringify(responseData),"Login Result")
//  

if(responseData.status === 'Email Already Exists'){
alert("Email Already Exists!");
}else{
    alert("Signup Successful!");
    localStorage.setItem('cid', (JSON.stringify(responseData.Customer_id)));
     navigate('/')
    //{"Customer_id":"2","status":"Login Successfully"}
}

})
}




const gotologin = async () =>{
    navigate('/')
}

return(
<div className="u-body u-xl-mode" data-lang="en">
<div style={{backgroundColor:"#5CD2EE",height:"50px",justifyContent:"center",justifyItems:"center",flexDirection:"row",}}>
{/* <img  src={require('./images/back.png')} style={{width:"35px",height:"35px",justifySelf:"center",marginTop:"5px"}}/> */}

        </div>
<section  className="u-section-1" id="sec-5b86">
<div className="u-clearfix u-sheet u-sheet-1">
<div style={{backgroundColor:"#fff"}} className="u-align-center u-container-style u-expanded-width-xs u-grey-90 u-group u-radius-19 u-shape-round u-group-1">
<div style={{backgroundColor:"#fff"}} className="u-container-layout u-valign-top-lg u-valign-top-md u-valign-top-sm u-valign-top-xl u-container-layout-1">
<div style={{backgroundColor:"#000"}}  className="u-container-style u-expanded-width u-group u-radius-13 u-shape-round u-white u-group-2">
<div style={{backgroundColor:"#5CD2EE"}} className="u-container-layout u-valign-middle-lg u-valign-middle-md u-valign-middle-sm u-valign-middle-xl u-container-layout-2">
<h2 style={{color:"white"}} className="u-text  u-text-default u-text-1">Signup</h2>
</div>
</div>
<div className="u-form u-login-control u-form-1">
<div className="u-form-group u-form-name u-label-top" >
<label for="username-a30d" className="u-label u-text-body-alt-color u-label-1">Email *</label>
<input type="text" placeholder="Enter your Email" id="username-a30d" name="email" style={{borderColor:"#5CD2EE",borderWidth:1}}
className="u-border-8 u-border-white u-input u-input-rectangle u-radius-20 u-white u-input-1" 
onChange={(e)=>setUser(e.target.value)} required=""/>
</div>
<div className="u-form-group u-form-password u-label-top">
<label for="password-a30d" className="u-label u-text-body-alt-color u-label-2">Password *</label>
<input type="text" placeholder="Enter your Password" id="password-a30d" name="password" 
className="u-border-8 u-border-white u-input u-input-rectangle u-radius-20 u-white u-input-2" 
required="" onChange={(e)=>setPassword(e.target.value)} style={{borderColor:"#5CD2EE",borderWidth:1}}/>
</div>
<div className="u-form-checkbox u-form-group u-label-top">

</div>
<div style={{marginTop:"20px"}} className="u-align-center u-form-group u-form-submit u-label-top" >
<button onClick={()=>Login()} className=" mt-10 u-border-none u-btn u-btn-round u-btn-submit 
u-custom-color-1  u-radius-10 u-text-active-white u-text-hover-white u-text-white " 
style={{alignSelf:'center',border: "none",width:"98%",
fontWeight: "700",height:"55px",
textTransform: "uppercase",
letterspacing: "1px",
backgroundColor:"#5CD2EE",

padding: "16px 30px 20px"}}>Sign Up</button>
</div>

</div>
<p onClick={()=>gotologin()} style={{color:"#5CD2EE",alignSelf:"flex-end",marginRight:"20px",cursor:"pointer"}}>Already Have Account? LogIn</p>
</div>
</div>
</div>
</section>
</div>
)
}

export default Register;